import { ReactNode } from 'react';

import TableHeaderIcon from '@components/typography/icons/TableHeaderIcon';
import styles from '@components/typography/Typography.module.css';
import { IconName } from '@utils/iconUtils';

type Props = {
  icon?: IconName;
  text: ReactNode;
};

const TableHeader = ({ icon, text }: Props) => (
  <div className={styles.tableHeader}>
    {text}
    {icon && (
      <span>
        <TableHeaderIcon icon={icon} />
      </span>
    )}
  </div>
);

export default TableHeader;
